import * as React from 'react';
import Svg, { G, Rect, Defs, } from 'react-native-svg';
function Circle(props) {
    return (React.createElement(Svg, { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(G, { filter: 'url(#filter0_d_3080_11331)' },
            React.createElement(Rect, { x: 2.5, y: 1.5, width: 19, height: 19, rx: 9.5, stroke: props.color })),
        React.createElement(Defs, null)));
}
export default Circle;
